import { defineMessages } from 'react-intl';

export default defineMessages({
  'dt:template_type:email': {
    id: 'dt:template_type:email',
    defaultMessage: 'Email',
  },
  'dt:template_type:email_attachment': {
    id: 'dt:template_type:email_attachment',
    defaultMessage: 'Email attachment',
  },
  'dt:template_type:label': {
    id: 'dt:template_type:label',
    defaultMessage: 'Label',
  },
  'dt:template_type:pickup': {
    id: 'dt:template_type:pickup',
    defaultMessage: 'Pickup',
  },
  'dt:template_type:pack': {
    id: 'dt:template_type:pack',
    defaultMessage: 'Pack',
  },
  'dt:template_type:pick': {
    id: 'dt:template_type:pick',
    defaultMessage: 'Pick',
  },
  'dt:template_type:print': {
    id: 'dt:template_type:print',
    defaultMessage: 'Print',
  },
  'dt:template_type:sms': {
    id: 'dt:template_type:sms',
    defaultMessage: 'SMS',
  },
  'dt:template_type:thermal_print': {
    id: 'dt:template_type:thermal_print',
    defaultMessage: 'Thermal print',
  },
});
